export enum LDist {
    EVEN="even",
    FILL="fill",
}